// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.update_button {
    width: 100%;
    --tw-bg-opacity: 1;
    background-color: rgb(250 204 21 / var(--tw-bg-opacity, 1));
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
    padding-left: 0.5rem;
    padding-right: 0.5rem;
    text-align: center
}`, "",{"version":3,"sources":["webpack://./src/components/LogicBuilder/LogicalBuilder/logicalbuilder.css"],"names":[],"mappings":"AACI;IAAA,WAAiD;IAAjD,kBAAiD;IAAjD,2DAAiD;IAAjD,oBAAiD;IAAjD,uBAAiD;IAAjD,oBAAiD;IAAjD,qBAAiD;IAAjD;AAAiD","sourcesContent":[".update_button {\n    @apply w-full text-center py-3 px-2 bg-yellow-400;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
